{
  "DATA_ASSISTANT": {
    "TITLE": "Assistent de dades",
    "NEW_CONVERSATION": "+ Nova",
    "LOADING": "Carregant...",
    "LOADING_MESSAGES": "Carregant missatges...",
    "THINKING": "Pensant...",
    "UNTITLED": "Conversa sense títol",
    "NO_CONVERSATIONS": "Encara no hi ha converses. Fes clic a \"+ Nova\" per començar.",
    "EMPTY_STATE": "Selecciona una conversa o crea'n una de nova per començar.",
    "PLACEHOLDER": "Què puc esbrinar per a tu?",
    "SHOW_SQL": "Mostra SQL",
    "NO_ROWS": "No s'ha retornat cap fila.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Suprimeix la conversa",
    "DELETE_CONFIRM_DESCRIPTION": "Estàs segur que vols suprimir aquesta conversa? Aquesta acció no es pot desfer.",
    "DELETE_CONFIRM_YES": "Suprimeix",
    "REPORTS": "Informes",
    "SAVE_TO_REPORT": "Desa a l'informe",
    "NEW_REPORT": "Informe nou",
    "REPORT_NAME": "Nom de l'informe",
    "NO_REPORTS": "Encara no hi ha informes desats",
    "REPORTS_EMPTY_STATE": "Selecciona un informe o crea'n un de nou.",
    "REPORT_SAVED": "Desat a l'informe",
    "DELETE_REPORT_CONFIRM": "Suprimeix l'informe",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Estàs segur que vols suprimir aquest informe? S'eliminaran tots els elements desats.",
    "DELETE_ITEM_CONFIRM": "Elimina l'element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Estàs segur que vols eliminar aquest element de l'informe?",
    "EXPORT_CSV": "Exporta CSV",
    "REFRESH": "Actualitza",
    "QUERY_RUNNING": "S'està executant la consulta...",
    "QUERY_FAILED": "La consulta ha fallat",
    "AUTO_REFRESH": "Actualització automàtica",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 segons",
    "AUTO_REFRESH_1M": "1 minut",
    "AUTO_REFRESH_5M": "5 minuts",
    "AUTO_REFRESH_10M": "10 minuts",
    "EDIT_MESSAGE": "Edita el missatge",
    "RENAME_REPORT": "Canvia el nom de l'informe",
    "RENAME_ITEM": "Canvia el nom de l'element",
    "MOVE_UP": "Mou amunt",
    "MOVE_DOWN": "Mou avall",
    "COLLABORATORS": {
      "BUTTON": "Col·laboradors",
      "TITLE": "Col·laboradors de l'informe",
      "DESCRIPTION": "Tria quins agents i equips poden veure aquest informe.",
      "AGENTS": "Agents",
      "TEAMS": "Equips",
      "SELECT_AGENTS": "Selecciona agents",
      "SELECT_TEAMS": "Selecciona equips",
      "SAVE": "Desa",
      "SAVED": "S'han actualitzat els col·laboradors",
      "SAVE_FAILED": "No s'han pogut actualitzar els col·laboradors"
    }
  }
}
